import Axios from "axios";
import {
    SET_BUDGET_VARIANCE_REPORT_LIST,
    UNSET_BUDGET_VARIANCE_REPORT_LIST,
    SET_BUDGET_CONSUMPTION_REPORT_LIST,
    UNSET_BUDGET_CONSUMPTION_REPORT_LIST,
    SET_BUDGET_OVERRUN_REPORT_LIST,
    UNSET_BUDGET_OVERRUN_REPORT_LIST,
    SET_BUDGET_SUMMARY_REPORT_LIST,
    UNSET_BUDGET_SUMMARY_REPORT_LIST,
} from "@/store/mutation-types";
import { 
    budgetVarianceReport,
    budgetConsumptionReport,
    budgetOverrunReport,
    budgetSummaryReport,
} from "@/store/api";

const state = {
    getBudgetVarianceReport: [],
    getBudgetConsumptionReport: [],
    getBudgetOverrunReport: [],
    getBudgetSummaryReport: [],
};

const getters = {
    getBudgetVarianceReport(state) {
        return state.getBudgetVarianceReport;
    },
    getBudgetConsumptionReport(state) {
        return state.getBudgetConsumptionReport;
    },
    getBudgetOverrunReport(state) {
        return state.getBudgetOverrunReport;
    },
    getBudgetSummaryReport(state) {
        return state.getBudgetSummaryReport;
    },
};

const mutations = {
    [SET_BUDGET_VARIANCE_REPORT_LIST](state, data) {
        state.getBudgetVarianceReport = data;
    },
    [UNSET_BUDGET_VARIANCE_REPORT_LIST](state) {
        state.getBudgetVarianceReport = [];
    },

    [SET_BUDGET_CONSUMPTION_REPORT_LIST](state, data) {
        state.getBudgetConsumptionReport = data;
    },
    [UNSET_BUDGET_CONSUMPTION_REPORT_LIST](state) {
        state.getBudgetConsumptionReport = [];
    },

    [SET_BUDGET_OVERRUN_REPORT_LIST](state, data) {
        state.getBudgetOverrunReport = data;
    },
    [UNSET_BUDGET_OVERRUN_REPORT_LIST](state) {
        state.getBudgetOverrunReport = [];
    },

    [SET_BUDGET_SUMMARY_REPORT_LIST](state, data) {
        state.getBudgetSummaryReport = data;
    },
    [UNSET_BUDGET_SUMMARY_REPORT_LIST](state) {
        state.getBudgetSummaryReport = [];
    },
};

const actions = {
    getBudgetVarianceReport({ commit }, data) {
        return new Promise((resolve, reject) => {
        Axios.post(budgetVarianceReport, data)
            .then(function (response) {
                commit('SET_BUDGET_VARIANCE_REPORT_LIST', response.data.data);
                resolve(response);
            })
            .catch(function (error) {
                commit('UNSET_BUDGET_VARIANCE_REPORT_LIST');
                reject(error);
            });
        });
    },

    getBudgetConsumptionReport({ commit }, data) {
        return new Promise((resolve, reject) => {
        Axios.post(budgetConsumptionReport, data)
            .then(function (response) {
                commit('SET_BUDGET_CONSUMPTION_REPORT_LIST', response.data.data);
                resolve(response);
            })
            .catch(function (error) {
                commit('UNSET_BUDGET_CONSUMPTION_REPORT_LIST');
                reject(error);
            });
        });
    },

    getBudgetOverrunReport({ commit }, data) {
        return new Promise((resolve, reject) => {
        Axios.post(budgetOverrunReport, data)
            .then(function (response) {
                commit('SET_BUDGET_OVERRUN_REPORT_LIST', response.data.data);
                resolve(response);
            })
            .catch(function (error) {
                commit('UNSET_BUDGET_OVERRUN_REPORT_LIST');
                reject(error);
            });
        });
    },

    getBudgetSummaryReport({ commit }, data) {
        return new Promise((resolve, reject) => {
        Axios.post(budgetSummaryReport, data)
            .then(function (response) {
                commit('SET_BUDGET_SUMMARY_REPORT_LIST', response.data.data);
                resolve(response);
            })
            .catch(function (error) {
                commit('UNSET_BUDGET_SUMMARY_REPORT_LIST');
                reject(error);
            });
        });
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

